module.exports = __webpack_public_path__ + "static/netlify-cms-logo-5a5d3304b7d2d77ea281363a71dcc970.svg";